import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalCommon from "../../ModalCommon";
import TitleSectionModal from "components/TitleSectionModal";
import { useState } from "react";
import ButtonModalCommon from "components/ModalCommon/ButtonModalCommon";
import { useParams } from "react-router-dom";
import { apiService } from "constants/axiosInstance";
import { useDispatch } from "react-redux";
import { actionToast } from "actions/system/system";
import {
  COPY_GROUP_TASK,
  CREATE_GROUP_TASK,
  CREATE_TASK,
  CustomEventEmitter,
} from "../../../constants/events";
import { useEffect } from "react";

const ModalCopyGroupTask = ({ group, open, setOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [name, setName] = useState("Copy " + group?.name);
  const [isCopyMember, setIsCopyMember] = useState(true);
  useEffect(() => {
    setName("Copy " + group?.name);
    setIsCopyMember(true);
  }, [group]);
  const { projectId } = useParams();
  const handleToast = (type, message) => {
    dispatch(actionToast(type, message));
    setTimeout(() => dispatch(actionToast(null, "")), 2000);
  };
  const handleCopy = async () => {
    try {
      await apiService({
        url: "/project/copy-group-task",
        method: "post",
        data: {
          group_task_id: group.id,
          project_id: projectId,
          name,
          is_copy_member: isCopyMember,
        },
      });
      CustomEventEmitter(COPY_GROUP_TASK.SUCCESS);
      setOpen(false);
    } catch (e) {
      console.log(e.message, "e e e");
      if (e.message) {
        handleToast("error", e.message);
      }
    }
  };

  return (
    <ModalCommon
      title={t("COPY_GROUP_TASK")}
      open={open}
      setOpen={setOpen}
      btnActionsRight={[
        <ButtonModalCommon onClick={() => setOpen(false)}>
          {t("DMH.COMP.CUSTOM_MODAL.CANCLE")}
        </ButtonModalCommon>,
        <ButtonModalCommon
          variant="contained"
          onClick={() => {
            handleCopy();
          }}
        >
          {t("Complete")}
        </ButtonModalCommon>,
        // <ButtonModalCommon variant="contained">Hoàn thành</ButtonModalCommon>,
      ]}
      sxPaperWidthSm={{
        minHeight: "250px",
      }}
      sxDialogContent={{
        paddingBottom: "0px",
      }}
    >
      <TitleSectionModal
        label={t("COPY_GROUP_TASK_NAME")}
        style={{ marginTop: 0 }}
      />
      <TextField
        placeholder={t("COPY_GROUP_TASK_NAME")}
        variant="outlined"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        InputProps={{
          style: { color: "#666" },
        }}
      />
      <TitleSectionModal
        label={t("COPY_GROUP_TASK_MEMBERS")}
        style={{ marginTop: 15 }}
      />
      <RadioGroup
        aria-label="member-setting"
        name="member-setting"
        value={isCopyMember}
        onChange={(evt) => setIsCopyMember(evt.target.value === "true")}
      >
        <FormControlLabel
          value={true}
          control={<Radio color="primary" />}
          label={t("COPY_GROUP_TASK_MEMBERS_KEEP")}
        />
        <FormControlLabel
          value={false}
          control={<Radio color="primary" />}
          label={t("COPY_GROUP_TASK_MEMBERS_REMOVE")}
        />
      </RadioGroup>
      <p>{t("COPY_GROUP_TASK_MEMBERS_DES")}</p>
    </ModalCommon>
  );
};

export default ModalCopyGroupTask;
